import axios from "axios"
import * as XLSX from 'xlsx';

import AiAgentService from "@/services/cis-aiagent.service";

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

const boldStyle = { font: { name: 'Consolas', bold: true } };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };
const stringStyle = { font: { name: 'Consolas' } };
const indexNumStyle = { font: { name: 'Consolas' }, numFmt: "0" };
const intNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0" };
const intNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0;[Red]\\ \\▼#,##0;[Black]\\ \"-\"" };
const rateNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0%" };
const rateNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0%;[Red]\\ \\▼#,##0%;[Black]\\ \"-\"" };

export default class ExpXlShareofSearch {
  constructor() {
    XLSX = require("xlsx-js-style");
  }

  newSheet4Data(columns, data) {
    var tmp_sheet = [];

    // Header
    var header_list = ['No.', '키워드'].concat(columns)
    var tmp_header = [];

    for (const col_nm of header_list) {
      tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
    };

    tmp_sheet.push(tmp_header);

    // Data
    var totalFreq = 0;
    var totalRate = 0;

    // Frequence summation
    for (const idx in data)
      totalFreq += Number(data[idx].freq);

    for (const idx in data) {
      var tmp_row = [];
      var rate = totalFreq == 0 ? 0 : Number(data[idx].freq) / totalFreq

      tmp_row.push({t: "n", v: Number(idx) + 1, s: indexNumStyle});       // No.
      tmp_row.push({t: "s", v: data[idx].keyword, s: stringStyle});       // 키워드
      tmp_row.push({t: "n", v: Number(data[idx].freq), s: intNumStyle});  // 검색량        
      tmp_row.push({t: "n", v: rate, s: rateNumStyle});                   // 비율        

      totalRate += rate;

      tmp_sheet.push(tmp_row)
    }

    // Total Row
    tmp_sheet.push([]);
    tmp_sheet.push(['', {t: "s", v: 'Total', s: stringStyle}, {t: "n", v: totalFreq, s: intNumStyle}, {t: "n", v: totalRate, s: rateNumStyle}
                    ]);
    
    var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
    //ws['!cols'] = this.autoFit(tmp_sheet)

    return ws;
  }

  newSheet4TrackingData(columns, data) {
    var tmp_sheet = [];
    var freqTotal = [];
    var rateTotal = [];

    // Header
    var header_list = ['No.', '키워드'].concat(columns)
    var tmp_header = [];

    for (const col_nm of header_list) {
      tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
      freqTotal.push(0);
      rateTotal.push(0);
    };

    tmp_sheet.push([{ v: '검색량', t: "s", s: boldStyle }]);
    tmp_sheet.push(tmp_header);

    // 검색량 Data
    for (const idx in data) {
      var tmp_row = [];
      tmp_row.push({t: "n", v: Number(idx) + 1, s: indexNumStyle}); // No.
      tmp_row.push({t: "s", v: data[idx].keyword, s: stringStyle}); // 키워드

      var sub_idx = 0;
      for (const sub_item of data[idx].freq) {  // 검색량
          tmp_row.push({t: "n", v: Number(sub_item), s: intNumStyle});
          freqTotal[sub_idx] += Number(sub_item);
          sub_idx++;
      };

      tmp_sheet.push(tmp_row)
    }

    var freqTotalRow = ['', 'Total'];

    for (const idx in columns)
      freqTotalRow.push({t: "n", v: Number(freqTotal[idx]), s: intNumStyle});

    tmp_sheet.push([]);
    tmp_sheet.push(freqTotalRow);
    tmp_sheet.push([]);
    tmp_sheet.push([]);
    tmp_sheet.push([{ v: '비율', t: "s", s: boldStyle }]);
    tmp_sheet.push(tmp_header);

    // 비율 Data
    for (const idx in data) {
      var tmp_row = [];
      tmp_row.push({t: "n", v: Number(idx) + 1, s: indexNumStyle}); // No.
      tmp_row.push({t: "s", v: data[idx].keyword, s: stringStyle}); // 키워드

      var sub_idx = 0;
      for (const sub_item of data[idx].rate) {  // 비율
          tmp_row.push({t: "n", v: Number(sub_item / 100).toFixed(5), s: rateNumStyle});
          rateTotal[sub_idx] += Number(sub_item);
          sub_idx++;
      };

      tmp_sheet.push(tmp_row)
    }

    var rateTotalRow = ['', 'Total'];

    for (const idx in columns)
      rateTotalRow.push({t: "n", v: Number(rateTotal[idx] / 100).toFixed(5), s: rateNumStyle});

    tmp_sheet.push([]);
    tmp_sheet.push(rateTotalRow);
    
    var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
    //ws['!cols'] = this.autoFit(tmp_sheet)

    return ws;
  }

  newSheet4TopRankKeyword(columns, data) {
    var tmp_sheet = [];

    // Header
    var header_list = ['No.', '키워드'].concat(columns)
    var tmp_header = [];

    for (const col_nm of header_list) {
      tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
    };

    tmp_sheet.push(tmp_header);

    // Data
    for (const item of data) {
      var tmp_row = [];
      tmp_row.push({t: "n", v: Number(item.rank), s: indexNumStyle});                               // No.
      tmp_row.push({t: "s", v: item.keyword, s: stringStyle});                                      // 키워드
      tmp_row.push({t: "n", v: Number(item.frequency.trim().replaceAll(',', '')), s: intNumStyle}); // 검색량
      tmp_row.push({t: "s", v: item.brand, s: stringStyle});                                        // 브랜드  

      tmp_sheet.push(tmp_row)
    }
    
    var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
    //ws['!cols'] = this.autoFit(tmp_sheet)

    return ws;
  }

  async xlExport(cat_id, st_dt, en_dt, dataset, target_dir = "") {
    if (dataset.length == 0) 
      return ""

    const workbook = XLSX.utils.book_new()	// 엑셀 생성

    for (const sheet of dataset) {
      const sheet_nm = sheet.sheet_nm.replace(/[\/]/g, '').trim().substring(0, 31)

      switch (sheet.sheet_type) {
        case 0:
          XLSX.utils.book_append_sheet(workbook, 
                                        this.newSheet4Data(sheet.cat, sheet.data), 
                                        sheet_nm)
          break
        case 1:
          XLSX.utils.book_append_sheet(workbook, 
                                        this.newSheet4TrackingData(sheet.cat, sheet.data), 
                                        sheet_nm)
          break
        case 2:
          XLSX.utils.book_append_sheet(workbook, 
                                        this.newSheet4TopRankKeyword(sheet.cat, sheet.data), 
                                        sheet_nm)
          break
      }
    }

    // 엑셀 → ArrayBuffer 변환
    const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Blob으로 변환 후 FormData에 담아 전송
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const file_nm = 'share_of_search_' + cat_id + '_' + st_dt + '_' + en_dt + '.xlsx'

    const formData = new FormData();
    formData.append('file', blob, file_nm);
    formData.append('filename', file_nm); // 저장 경로 전달
    formData.append('target_dir', target_dir);

    const response = await AiAgentService.callAiAgent_SaveExcel(formData, source)

    if(response && response.status == 200)
      return response.data.data.path
      // return response.data.path // for local test
    else
      return ""
  }
}